/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {RJSFSchemas} from './RJSFSchemas';
import {RJSFSchemasFromJSON, RJSFSchemasFromJSONTyped, RJSFSchemasToJSON} from './RJSFSchemas';
import type {WorkZone} from './WorkZone';
import {WorkZoneFromJSON, WorkZoneFromJSONTyped, WorkZoneToJSON} from './WorkZone';

/**
 *
 * @export
 * @interface LogicalUpdateOut
 */
export interface LogicalUpdateOut {
  /**
   *
   * @type {boolean}
   * @memberof LogicalUpdateOut
   */
  treeChanged?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LogicalUpdateOut
   */
  dataChanged: boolean;
  /**
   *
   * @type {{ [key: string]: RJSFSchemas; }}
   * @memberof LogicalUpdateOut
   */
  schemas: {[key: string]: RJSFSchemas} | null;
  /**
   *
   * @type {string}
   * @memberof LogicalUpdateOut
   */
  name: string | null;
  /**
   *
   * @type {boolean}
   * @memberof LogicalUpdateOut
   */
  workzoneChanged: boolean;
  /**
   *
   * @type {WorkZone}
   * @memberof LogicalUpdateOut
   */
  graphzone: WorkZone | null;
}

/**
 * Check if a given object implements the LogicalUpdateOut interface.
 */
export function instanceOfLogicalUpdateOut(value: object): value is LogicalUpdateOut {
  if (!('dataChanged' in value) || value['dataChanged'] === undefined) return false;
  if (!('schemas' in value) || value['schemas'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('workzoneChanged' in value) || value['workzoneChanged'] === undefined) return false;
  if (!('graphzone' in value) || value['graphzone'] === undefined) return false;
  return true;
}

export function LogicalUpdateOutFromJSON(json: any): LogicalUpdateOut {
  return LogicalUpdateOutFromJSONTyped(json, false);
}

export function LogicalUpdateOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LogicalUpdateOut {
  if (json == null) {
    return json;
  }
  return {
    treeChanged: json['tree_changed'] == null ? undefined : json['tree_changed'],
    dataChanged: json['data_changed'],
    schemas: json['schemas'] == null ? null : mapValues(json['schemas'], RJSFSchemasFromJSON),
    name: json['name'],
    workzoneChanged: json['workzone_changed'],
    graphzone: WorkZoneFromJSON(json['graphzone'])
  };
}

export function LogicalUpdateOutToJSON(value?: LogicalUpdateOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    tree_changed: value['treeChanged'],
    data_changed: value['dataChanged'],
    schemas: value['schemas'] == null ? null : mapValues(value['schemas'], RJSFSchemasToJSON),
    name: value['name'],
    workzone_changed: value['workzoneChanged'],
    graphzone: WorkZoneToJSON(value['graphzone'])
  };
}
